import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';


import * as asideactions from '../aside/aside.actions';


@Injectable()
export class AsideEffects {

    constructor(
        // private userService: UserService,
        private actions$: Actions
    ) { }

    

}
